/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
// Utils
// import { notifyPaymentRequired } from 'common/utils/customerValidation'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'

// Styled Elements
import {
  MenuDetailedWrapper,
  Header,
  XStack,
  YStack,
  Divider,
  MenuNavLink
} from '../common.elements'

// Map Redux Props
function MoreSidebar() {
  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', {})
  return (
    <MenuDetailedWrapper style={{ flexDirection: 'column-reverse', paddingBottom: '40px' }}>
      <YStack style={{ gap: '8px' }}>

        <YStack style={{ padding: '0 8px' }}>

          <MenuNavLink
            to="#"
            onClick={(e) => {
              e.preventDefault();
              window.open('https://docs.ospree.io/ospree-api/overview', '_blank')
            }}
          >API Documentation
          </MenuNavLink>
          {/* <MenuNavLink style={{ justifyContent: 'flex-start' }} fullWidth variant="transparent" size="small" onClick={() => window.open('https://www.ospree.io/help-center', '_blank')}>Get Help</MenuNavLink> */}
          <MenuNavLink
            to="#"
            onClick={(e) => {
              e.preventDefault();
              window.open('https://www.ospree.io/legal/terms-and-conditions', '_blank')
            }}
          >Terms of Use
          </MenuNavLink>

          {userCredentials?.role_id === 0 && (
            <MenuNavLink to="/admin/ai/documents">AI Documents</MenuNavLink>
          )}
          {userCredentials?.role_id === 0 && (
            <MenuNavLink to="/admin/vasps">Admin Vasps</MenuNavLink>
          )}

          <XStack style={{ padding: '8px 15px 15px 15px' }}>
            <Divider />
          </XStack>

          <YStack style={{ gap: '8px', padding: '0 15px' }}>
            {/* <Text>{`${userCredentials?.email}`}</Text> */}
            <XStack style={{ alignItems: 'center', gap: '12px' }}>
              <Header>More Options</Header>
            </XStack>
          </YStack>
        </YStack>
      </YStack>

    </MenuDetailedWrapper>
  )
}

export default MoreSidebar
